import React from "react";
import ReactDOM from "react-dom";
import TrackGuide from "../containers/TrackGuide";
import AppRenewal from "./AppRenewal";
import AppQuoteBuilder from "./AppQuoteBuilder";
import AppCustomQuote from "./AppCustomQuote";
import { Provider, useDispatch } from "react-redux";
import configureStore from "../configureStore";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../assets/stylesheets/react.scss";
import { BrowserRouter as Router } from "react-router-dom";

const store = configureStore();

const renderTrackGuide = () => {
	const container = document.getElementById("track-guide-container");
	if (!container) return;

	const { guideId } = container.dataset;

	ReactDOM.render(<TrackGuide guideId={guideId} />, container);
};

document.addEventListener("DOMContentLoaded", () => {
	renderTrackGuide();
});

document.addEventListener("DOMContentLoaded", () => {
	const container = document.getElementById("renewal-app");

	if (!container) return;

	const {
		renewalId,
		makeModels,
		municipalities,
		stripePubKey,
		customerName,
		helloSignCid,
		inspectletId,
		gaTrackingId,
		allowCreditCardPayments,
		productExceptionMessages
	} = container.dataset;

	const creditCardPayment = allowCreditCardPayments === "true";

	ReactDOM.render(
		<Router>
			<Provider store={store}>
				<AppRenewal
					renewalId={renewalId}
					makeModels={makeModels}
					municipalities={municipalities}
					stripePubKey={stripePubKey}
					customerName={customerName}
					helloSignCid={helloSignCid}
					inspectletId={inspectletId}
					gaTrackingId={gaTrackingId}
					allowCreditCardPayments={creditCardPayment}
					productExceptionMessages={productExceptionMessages}
				/>
			</Provider>
		</Router>,
		container
	);
});

document.addEventListener("DOMContentLoaded", () => {
	const container = document.getElementById("custom-quote-app");

	if (!container) return;

	const {
		renewalId,
		makeModels,
		municipalities,
		stripePubKey,
		customerName,
		helloSignCid,
		isCustomQuote,
		orderHashId,
		allowCreditCardPayments,
	} = container.dataset;

	const creditCardPayment = allowCreditCardPayments === "true";

	ReactDOM.render(
		<Router>
			<Provider store={store}>
				<AppCustomQuote
					renewalId={renewalId}
					makeModels={makeModels}
					municipalities={municipalities}
					stripePubKey={stripePubKey}
					customerName={customerName}
					helloSignCid={helloSignCid}
					orderHashId={orderHashId}
					allowCreditCardPayments={creditCardPayment}
				/>
			</Provider>
		</Router>,
		container
	);
});

document.addEventListener("DOMContentLoaded", () => {
	const container = document.getElementById("quotebuilder-app");

	if (!container) return;

	const { customerName, makeModels, municipalities, trackData, customerEmail } =
		container.dataset;

	ReactDOM.render(
		<Router>
			<Provider store={store}>
				<AppQuoteBuilder
					customerName={customerName}
					makeModels={makeModels}
					municipalities={municipalities}
					trackData={trackData}
					customerEmail={customerEmail}
				/>
			</Provider>
		</Router>,
		container
	);
});
